<template>
    <div v-if="documents" class="mb-5">
        <div class="scroll-area">
            <a
                v-for  = "(document, index) in documents"
                :key   = "index"
                @click = "onSelect(document)"
            >
                <v-hover
                    v-slot = "{ hover }"
                >
                    <div>
                        <div v-if="dateChanged (index)" class="date-header primary--text v-flex">
                            <div style="font-weight: 500">
                                {{ dateAsString (document.createdDate) }}
                            </div>
                            <v-spacer />

                            <div class="header-title primary--text">
                                Erstellung am / von
                            </div>
                        </div>
                        <p-dms-entry
                            :step-data-id = "stepDataId"
                            :category     = "category"
                            :document     = "document"
                            :hover        = "hover"
                            :compact      = "compact"
                            :index         = "index"
                            :block-indexes = "blockIndex"
                        />
                    </div>
                </v-hover>
            </a>
        </div>
    </div>
</template>

<script>

import Core      from "@/modules/core/service/Core";
import PDmsEntry from "@/modules/dms/menu/components/private/PDmsEntry.vue";

export default {
    name: "PDmsEntries",

    components: {
        PDmsEntry
    },

    props: {
        category: {

        },

        stepDataId: {

        },

        documents: {
            type: Array
        },

        compact: {
            required: false,
            type    : Boolean,
            default : () => {
                return false;
            }
        },
    },

    data: () => ({
        search: null,
        blockStartIndex: 0,
        blockIndex: [],
    }),

    watch: {
        documents () {
            this.initialize();
        }
    },

    mounted() {
        this.initialize();
    },

    methods: {
        initialize () {
            if (!this.documents) {
                return;
            }

            this.blockIndex = [];
            this.documents.forEach((d, index) => {
                this.blockIndex.push (this.isStartOfDateBlock(index));
            })
        },

        onSelect () {

        },

        dateChanged (index) {
            if (this.isStartOfDateBlock(index)) {
                this.blockStartIndex = index;
                return true;
            }

            return false;
        },

        dateAsString (value) {
            return Core.format.date.display(value)
        },

        isStartOfDateBlock (index) {
            if (index === 0) {
                return true;
            }

            return this.documents[index].createdDate
                && this.documents[index-1].createdDate
                && this.documents[index].createdDate.substring(0, 10) !== this.documents[index-1].createdDate.substring(0, 10)
        },
    }
}
</script>

<style scoped>
.scroll-area {
    max-height: 580px;
    overflow-y: scroll;
    overflow-x: hidden;
}

.date-header {
    font-size: 14px;
    color: black;
    margin: 16px 0 0;
    padding-left: 8px;
}

.header-title {
    font-size: 10px;
    margin-top: 7px;
    margin-right: 50px;
}

::v-deep .doc-entry {
    font-size: 15px;
    min-height: 50px;
    display: flex;
}
</style>